module.exports = __webpack_public_path__ + "static/img/18.b204add.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/18.jpg
// module id = JgCJ
// module chunks = 1